/*var BrandModel = (function() {
	var __private = {
		tagName: "SELECT",
		isAjax: false,
		isStatic: false,

		set(args) {
			this.mainSelect = document.querySelector(this.tagName + '[name=' + args.mainSelectName + ']');
			this.dependentSelect = document.querySelector(this.tagName + '[name=' + args.dependentSelectName + ']');

			this.firstHTML = args.firstHTML || "";

			if(args.hasOwnProperty("isAjax")) {
				this.isAjax = true;
				this.url = args.isAjax.url;
				this.method = args.isAjax.method || "GET";
				this.ajaxHeader = {
					header: args.header || "Content-Type",
					value: args.value   || "application/json"
				};
			} else if(args.hasOwnProperty("isStatic")) {
				this.isStatic = true;
				this.content = args.isStatic.content;
			}

			if(this.mainSelect && this.dependentSelect) this.listener();
		},

		listener() {
			this.mainSelect.addEventListener("change", function() {
				var value = this.value || "all";

				if(value) console.log(value);
				
				if(__private.isAjax) __private.setAjax(value);
				else if(__private.isStatic) __private.setStatic();
				else console.info("The method was not specified");
			});
		},

		setAjax(value) {
			var url = __private.url + '?brand=' + value;
			var xhr = new XMLHttpRequest();

			xhr.open(this.method, url, true);

			if(this.ajaxHeader && this.method === "POST") {
				xhr.setRequestHeader(this.ajaxHeader.header, this.ajaxHeader.value);
			}

			if(this.method === "GET") xhr.send();
			else xhr.send(value);

			xhr.onreadystatechange = function() {
				if (this.readyState != 4) return;
				if (this.status != 200) {
				  	// if error
					console.log('------------------------------------');
					console.log('URL: ' + url);
					console.log( 'ERROR: ' + (this.status ? this.statusText : 'request failed') );
					console.log(this);
					console.log('------------------------------------');
					return;
				}
			  
				// if success
				console.log('------------------------------------');
				console.log('URL: ' + url);
				console.log( 'SUCCESS: ' + (this.status ? this.statusText : 'request was fulfilled') );
				console.log(this);
				console.log('------------------------------------');

				__private.addContent(this.responseText);
			}

		},

		setStatic() {
			this.addContent(__private.content);
		},

		addContent(data) {
			var innerHtml = this.firstHTML + data;

			this.dependentSelect.innerHTML = innerHtml;
		}
	};

	return {
		init(args) {
			__private.set(args);
		}
	};
})();*/


(function() {
	// MODULE
	var LoadListings = (function() {
		var __private = {
			form: null,
			mainInput: null,
			dependentInput: null,
			method: "GET",
			url: "/ajax/item/list-models?makeId=",
			disable: false,
			disableClass: "disabled",

			set(form, options) {
				if(form && form instanceof HTMLElement) this.form = form;
				else throw new Error("Form not found");

				if(options) {
					if(options.mainInput && options.mainInput instanceof HTMLElement) {
						this.mainInput = options.mainInput;

						let value = this.mainInput.value;

						if(value && value != "") __private.request(__private.url + value);
					}
						
					if(options.dependentInput && options.dependentInput instanceof HTMLElement)
						this.dependentInput = options.dependentInput;

					if(options.url)     this.url     = options.url;
					if(options.method)  this.method  = options.method;
					if(options.disable) this.disable = true;
				}
			},

			listener() {
				if(this.mainInput instanceof HTMLElement) this.mainInput.addEventListener("change", function() {
					var value = this.value;

					if(value && value != "") __private.request(__private.url + value);
					else __private.setSelectList([]);
				});
			},

			request(url) {
				return new Promise(function(resolve, reject) {
					var data;
					var xhr = new XMLHttpRequest();

					xhr.open(__private.method, url, true);
					xhr.onload = function() {
						if (this.status == 200) {
							data = JSON.parse(xhr.responseText);
							resolve(__private.setSelectList(data));
						} else {
							var error = new Error(this.statusText);
							error.code = this.status;
							reject(error);
						}
					};
				
					xhr.onerror = function() {
					  	reject(new Error("Network Error"));
					};
				
					xhr.send();
				});
			},

			setSelectList(data) {
				var firstOption = `<option value="" selected="selected">(All models)</option>`;
				var options;

				if(data && __private.dependentInput instanceof HTMLSelectElement) {
					__private.dependentInput.innerHTML = firstOption;

					// was returned Array
					if(Array.isArray(data)) options = __private.isArr(data);

					// was returned Object
					else if(typeof data === "object") options = __private.isObj(data);

					__private.dependentInput.innerHTML += options;

					setTimeout(() => {
						var isSelected = false;
						var modelValue = __private.searchModel();

						for (let i = 1; i < __private.dependentInput.children.length; i++) {
							const option = __private.dependentInput.children[i];
							let val = +option.value;

							if(!isNaN(modelValue) && modelValue === val) {
								option.selected = true;
								isSelected = true;
							} else if(option.selected === true) isSelected = true;
						}

						if(!isSelected) __private.dependentInput.children[0].selected = true;
					}, 0);
				}
			},

			searchModel() {
				var search = typeof window.location.search === "string" && window.location.search.length > 0 ? window.location.search : false;
				var value = false;

				if(search) {
					search = search.replace("?", "");
					search = search.split("&");

					for (let i = 0; i < search.length; i++) {
						const element = search[i];

						if(element.indexOf("model=") > -1) {
							value = element.replace("model=", "");

							if(!isNaN(value)) value = +value;
							else value = false;

							break;
						}
						
					}
				}

				return value;
			},

			isArr(arr, obj) {
				var options = "";

				arr.sort();

				for (let i = 0; i < arr.length; i++) {
					const val = arr[i];
					let ID    = arr[i];

					// search ID in object
					if(obj && obj instanceof Object) {
						for (const key in obj) {
							if (obj.hasOwnProperty(key)) {
								const el = obj[key];
								
								if(el.toLowerCase() === val.toLowerCase()) {
									ID = key;
									break;
								}
							}
						}
					}

					options += `<option value="${ID}">${val}</option>`;
				}

				return options;
			},

			isObj(obj) {
				var arr = [];

				for (const key in obj) {
					if (obj.hasOwnProperty(key)) {
						const val = obj[key][0].toUpperCase() + obj[key].slice(1);
						arr.push(val);
					}
				}

				return __private.isArr(arr, obj);
			},

			setDependent(mainID, dependentID) {
				var url = __private.url + mainID;

				__private.switch(true);

				__private.request(url)
					.then(function() {
						if(__private.dependentInput instanceof HTMLSelectElement) __private.dependentInput.value = dependentID;
						__private.switch(false);
					})
					.catch(function() { console.log("Request is falled"); });
			},

			switch(disabled) {
				var form   = null;
				var button = null;

				if(__private.disable && __private.form instanceof HTMLElement) {
					if(__private.form instanceof HTMLFormElement) form = __private.form;
					else form = __private.form.querySelector("form");

					if(form instanceof HTMLFormElement) {
						button = form.querySelector("*[type='submit']");

						if(button instanceof HTMLElement) {
							switch (disabled) {
								case true:
									button.disabled = true;
									button.classList.add(__private.disableClass);
									break;
							
								case false:
									button.disabled = false;
									button.classList.remove(__private.disableClass);
									break;
							}
						}
					}
				}
			}
		};

		return {
			init(form, options) {
				__private.set(form, options);
				__private.listener();
			},

			dependent(mainID, dependentID, disable) {
				if(disable) __private.disable = true;
				__private.setDependent(mainID, dependentID);
			}
		};
	})();


	// run script
	document.addEventListener("DOMContentLoaded", function() {

		/**
		 * FILTER
		 */

		let form = document.querySelector("form.carFilter");

		if(form) {
			LoadListings.init(form, {
				mainInput: form.querySelector("select[name='brand']"),
				dependentInput: form.querySelector("select[name='model']"),
			});
		}


		/**
		 * EDIT ITEM
		 */

		let stepFormWrapper = document.querySelector(".steps__wrap");
		
		if(stepFormWrapper) {
			let stepsBrandSelect = stepFormWrapper.querySelector("select#car-brand-input");
			let stapsModelSelect = stepFormWrapper.querySelector("select#car-model-input");
			let brandID = false;
			let modelID = false;

			LoadListings.init(stepFormWrapper, {
				mainInput: stepsBrandSelect,
				dependentInput: stapsModelSelect
			});

			if(stepsBrandSelect instanceof HTMLSelectElement && stepsBrandSelect.value && stepsBrandSelect.value !== "") {
				brandID = stepsBrandSelect.value
			}

			if(stapsModelSelect instanceof HTMLSelectElement && stapsModelSelect.dataset.initialValue !== undefined) {
				modelID = stapsModelSelect.dataset.initialValue;
			}

			if(brandID && modelID) {
				LoadListings.dependent(brandID, modelID, true);
			}
		}

	});
})();